/** The five builder steps, in order, with their step codes and routes. Pure, no app imports. */
export const BUILDER_STEPS = [
  { number: 1, stepCode: "Create_New_Book", route: "/create-book" },
  { number: 2, stepCode: "Upload_Your_Cover_Photo", route: "/dashboard" },
  { number: 3, stepCode: "Upload_Images", route: "/create" },
  { number: 4, stepCode: "Design_Your_Cover_Page", route: "/cover-image" },
  { number: 5, stepCode: "Review_Your_Book", route: "/review" },
];

export const STEP_BY_CODE = Object.fromEntries(BUILDER_STEPS.map((s) => [s.stepCode, s.number]));

export const MAX_PHOTOS = 20;

/** The step number for a URL, or null off the builder. */
export function stepForLocation(pathname, search) {
  const code = new URLSearchParams(search).get("stepCode");
  if (code && STEP_BY_CODE[code]) return STEP_BY_CODE[code];
  // /dashboard without a stepCode is My Books, not step 2.
  const byRoute = BUILDER_STEPS.find((s) => s.route === pathname && s.route !== "/dashboard");
  return byRoute ? byRoute.number : null;
}
